import React from 'react'
import { Link } from 'react-router-dom'
import { translate } from 'react-i18next'

export default translate('common')(({ slug, t }) => (
  <Link to={{pathname: `/${slug}`, state: { to: 'trip'}}} className="button button--text scrolldown">
    <span className="scrolldown__label">{ t('scrolldown.label') }</span>
    <div className="scrolldown__holder">
      <div className="scrolldown__line" />
    </div>
  </Link>
))



// WEBPACK FOOTER //
// ./src/components/Global/Scrolldown.js